import SituacionLaboralShow from './SituacionLaboralShow'
export {SituacionLaboralShow}
export default SituacionLaboralShow
